import {
  ReportStage,
  ReportStatus,
} from 'donor/portal/pages/FeedbackDashboard/api';
import { CustomQuestionsById } from 'admin/pages/ManageAccounts/CustomQuestions/hook';
import { BeneficiaryRouteType } from '../../ReportBuilder/Components/Beneficiary/BeneficiaryRoutes';
import { Indicator } from '../../ReportBuilder/Components/ModalImpacts/GroupedIndicators';
import { IndicatorDetail } from '../../ReportBuilder/Components/SectionIndicators';
import { GuidanceTextResponse } from '../../ReportBuilder/Components/utils';
import { FeedbackCommentBodyWithIndex, SelectedFeedback } from '../utils';
import { FeedbackQuestion, FeedbackQuestionsById } from './api';
import { Report } from 'shared/components/WelcomeBack/utils';

// disableNext
export const disabledNextQuestionIds = [
  // allocations
  20008,
  20009,
  20016,
  // impact summary
  40004,
  40006,
  40009,
  // budget
  80003,
  80007,
  80005,
  80009,
  80011,
];

export const isNextQuestionDisabled = (
  questionId: number | undefined,
): boolean => {
  if (!questionId) return true;

  return disabledNextQuestionIds.includes(questionId);
};

export interface FeedbackSectionInfo {
  report: Report;
  reportId: number;
  isThirdParty: boolean;
  reportYear?: string;
  isReportPassed: boolean;
  reportStage: ReportStage;
  reportStatus: ReportStatus;
  questionId: number;
  questions: FeedbackQuestionsById;
  question: FeedbackQuestion;
  programName: string;
  questionText: string;
  feedbackByQuestionId: {
    [questionId: number]: FeedbackCommentBodyWithIndex[];
  };
  beneficiaryTerm: string | undefined;
  answer: string;
  guidanceText: GuidanceTextResponse;
  startDate: string | undefined;
  endDate: string | undefined;
  selectedSection: SelectedFeedback;
  loadingAnswers: boolean;
  initialRoute?: BeneficiaryRouteType;
  customQuestionsById: CustomQuestionsById;
  feedback: FeedbackCommentBodyWithIndex[];
  handleClose: () => unknown;
  setSelectedQuestion: (
    value: React.SetStateAction<FeedbackQuestion | undefined>,
  ) => unknown;
  reloadAnswers: () => unknown;
  handleCompleted: () => unknown;
  handleAnswerUpdate: (
    questionId: number,
    answer: string,
    questionText: string,
    questionType: FeedbackQuestion['questionType'],
  ) => unknown;
}

export interface FeedbackQuestionHandler {
  reportId: number;
  questionId: number;
  answer: () => string;
  onCompleted?: (answer: string) => unknown;
  onNextClicked?: () => unknown;
  onBackClicked?: () => unknown;
  errorText: () => string | undefined;
}

export const SOCIAL_IMPACT_STAGE_ID = 3;
export const REACH_STAGE_ID = 5;
export const getImpactIndicators = (
  indicators: IndicatorDetail[],
  serviceName: string,
  stageId: number = SOCIAL_IMPACT_STAGE_ID,
) => {
  const options: Indicator[] = [];
  const restIndicators: IndicatorDetail[] = [];
  const addedIndicatorIds: { [key: number]: 1 | undefined } = {};
  const addedIndicatorNames: { [key: string]: 1 | undefined } = {};
  const serviceIndex = indicators.findIndex(ind => ind.name === serviceName);

  if (serviceIndex !== -1) {
    const currentService = indicators[serviceIndex];
    indicators[serviceIndex] = indicators[0];
    indicators[0] = currentService;
  }

  for (let i = 0; i < indicators.length; i++) {
    const element = indicators[i];
    const currentIndicators: Indicator[] = [];
    element.indicators.forEach(ind => {
      const indicatorName = ind.name.toLowerCase();
      if (
        !addedIndicatorIds[ind.id] &&
        !addedIndicatorNames[indicatorName] &&
        ind.stageId === stageId
      ) {
        addedIndicatorIds[ind.id] = 1;
        addedIndicatorNames[indicatorName] = 1;
        i === 0 ? options.push(ind) : currentIndicators.push(ind);
      }
    });
    currentIndicators.length &&
      restIndicators.push({
        id: element.id,
        name: element.name,
        indicators: currentIndicators,
      });
  }
  return { options, restIndicators };
};
